import React, { useState, useEffect, useRef } from "react";
import Logo from "./Logo";
import styles from "../../styles/register.module.css";
import authImg from "../../assets/images/verification.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GetApi, PostApi } from "../../api/api-service";
import { API_Path } from "../../const";
import { toast } from "react-toastify";
import Loading from "../../components/loader/Loading";
import useFetch from "../../components/customHook/useFetch";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
var valueUrl;
export default function LoginAuthVerify() {
    const navigate = useNavigate();
    const location = useLocation();
    const [firstCoin, baseCoin, RunningPair] = useFetch();
    const [resendOTPFlag, setResendOTPFlag] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(true);
    const [otp, setOtp] = useState("");
    const [alertErrors, setAlertErrors] = useState([]);
    const [isShowMobileVerify, setIsShowMobileVerify] = useState(false);
    const [userModel, setUserModel] = useState({
        EmailIdOrApi: "",
        OneTimeCode: "",
        LoginSafetyCode: "",
        MobileNo: "",
        IsMobileAuthentication: false,
        OtpCode: "",
    });
    const [btnLoader, setBtnLoader] = useState({
        sendOtpLoader: false,
        reSendOtpLoader: false,
    });
    const [isVisible, setIsVisible] = useState(false);
    const [timeLeft, setTimeLeft] = useState(30);
    const intervalRef = useRef();

    useEffect(() => {
        const sPageURL = window.location.href;
        const indexOfLastSlash = sPageURL.lastIndexOf("/");

        if (indexOfLastSlash > 0 && sPageURL.length - 1 !== indexOfLastSlash) {
            const extractedValue = sPageURL.substring(indexOfLastSlash + 1);
            valueUrl = extractedValue;
        }
    }, []);

    useEffect(() => {
        setLoader(true);
        loginVerifyGetUser();
    }, []);

    useEffect(() => {
        if (timeLeft <= 0) clearInterval(intervalRef.current);
    }, [timeLeft]);

    const formattedTime = String(timeLeft).padStart(2, "0");

    useEffect(() => {
        if (isVisible) {
            intervalRef.current = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(intervalRef.current); // Clean up the interval on unmount or time change
        }
    }, [isVisible]);

    const loginVerifyGetUser = () => {
        const loginVerifyGetUserData = new Promise((resolve) => {
            resolve(GetApi(API_Path.loginVerifyGetUser + valueUrl));
        });
        loginVerifyGetUserData.then((res) => {
            if (res) {
                if (res.data.Isvalid) {
                    var responseModel = res.data.Model;
                    setUserModel({
                        EmailIdOrApi: responseModel.EmailIdOrApi,
                        LoginSafetyCode: responseModel.LoginSafetyCode != null && responseModel.LoginSafetyCode,
                        MobileNo: responseModel.MobileNo,
                        IsMobileAuthentication: responseModel.IsMobileAuthentication,
                    });
                    setLoader(false);
                } else {
                    setAlertErrors(res.data.Errors);
                    setLoader(false);
                }
            } else {
                toast.error("Something went wrong!");
            }
            setLoader(false);
        });
    };

    const setSubmitData = (formdata) => {
        setLoading(true);
        let data = {
            EncryptedUrl: valueUrl,
            AuthenticatorCode: !isShowMobileVerify ? formdata.otp : "",
            IsVerifyByMobileOtp: isShowMobileVerify,
            OtpCode: isShowMobileVerify ? formdata.otp : "",
        };
        const getCryptoCurrency = new Promise((resolve) => {
            resolve(PostApi(API_Path.userLoginAuthVerify, data));
        });
        getCryptoCurrency.then((res) => {
            if (res.data.Isvalid) {
                let auth = res.data.Model.Token;
                let email = res.data.Model.UserName;
                localStorage.setItem("BasketAuthorizationData", auth);
                localStorage.setItem("FunexAuthData", email);
                localStorage.setItem("RunningPair", RunningPair.toUpperCase());
                localStorage.setItem("FirstCoin", firstCoin.toUpperCase());
                localStorage.setItem("BaseCoin", baseCoin.toUpperCase());
                navigate(`/trading/advance/${firstCoin.toUpperCase()}_${baseCoin.toUpperCase()}`);
                toast.success(res.data.Successes[0]);
            } else {
                toast.error(res.data.Errors[0]);
            }
            setLoading(false);
        });
    };
    

    const SendLoginVerifyMobileOtp = () => {
        setBtnLoader({ sendOtpLoader: true });
        let data = {
            EncryptedUrl: valueUrl,
        };
        const getCryptoCurrency = new Promise((resolve) => {
            resolve(PostApi(API_Path.SendLoginVerifyMobileOtp, data));
        });
        getCryptoCurrency.then((res) => {
            if (res.data.Isvalid) {
                setIsVisible(true);
                setTimeLeft(30);
                toast.success(res.data.Successes[0]);
            } else {
                toast.error(res.data.Errors[0]);
            }
            setBtnLoader({ sendOtpLoader: false });
            setTimeout(() => {
                setIsVisible(false);
                setResendOTPFlag(true);
                setBtnLoader({ sendOtpLoader: false });
            }, 30100);
        });
    };

    return (
        <React.Fragment>
            {loader && <Loading />}
            <div className="container-fluid">
                <div className="row">
                    <div className={`${styles.col_width_left} ${styles.col_width_flex}`}>
                        <div className={styles.main_box}>
                            <div className={styles.lr_logo}>
                                <Logo />
                            </div>
                            <div className="mb-4">
                                <h3>Login Verify</h3>
                            </div>
                            {alertErrors.length > 0 && (
                                <div>
                                    {alertErrors?.map((item, i) => (
                                        <div className="alert alert-danger mb-1" key={i}>
                                            <span>{item}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {alertErrors.length <= 0 && (
                                <>
                                    {userModel.LoginSafetyCode != "" && <p className={styles.sefty_code}>{userModel.LoginSafetyCode}</p>}
                                    <div className={`${styles.agreeTermsStyle} my-4`}>
                                        {!isShowMobileVerify ? "Please enter the code generated by Google Authenticator." : "Please enter the Login OTP received by SMS."}
                                    </div>
                                    {!isShowMobileVerify ? (
                                        <div className={`${styles.agreeTermsStyle} my-4`}>
                                            Email Address : <b>{userModel?.EmailIdOrApi}</b>
                                        </div>
                                    ) : (
                                        <div className={`${styles.login_bottomtext} mb-4`}>
                                            <b>Mobile No : {userModel?.MobileNo}</b>
                                            {/* <button type="button" className={`${styles.btn_link} ms-2`} onClick={SendLoginVerifyMobileOtp} disabled>
                                                SMS Send OTP
                                            </button> */}
                                        </div>
                                    )}

                                    <Formik
                                        initialValues={{ otp: "" }}
                                        validationSchema={Yup.object().shape({
                                            otp: Yup.string().required("Authentication code is required."),
                                        })}
                                        onSubmit={(values, { resetForm }) => {
                                            setSubmitData(values, resetForm);
                                        }}
                                    >
                                        {(runform) => {
                                            const { touched, errors } = runform;
                                            return (
                                                <Form onSubmit={runform.handleSubmit}>
                                                    <div className={`${styles.inputWidth} mb-3`}>
                                                        <label className={`${styles.login_label_text} d-block`}></label>
                                                        <div className="d-block position-relative">
                                                            <Field
                                                                type="text"
                                                                name="otp"
                                                                placeholder={isShowMobileVerify ? "Enter OTP code" : "Enter authentication code"}
                                                                // autoFocus={true}
                                                                className={` ${styles.login_comn_input} ${errors.otp && touched.otp ? "input-error" : ""}`}
                                                                maxLength={6}
                                                            />
                                                            {isShowMobileVerify && (
                                                                <>
                                                                    {isVisible ? (
                                                                        <button type="button" className={`${styles.auth_login_btn} cursor-not-allowed`}>
                                                                            00:{formattedTime}
                                                                            {btnLoader.sendOtpLoader && !isVisible && (
                                                                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                                                            )}
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className={styles.auth_login_btn}
                                                                            onClick={() => {
                                                                                SendLoginVerifyMobileOtp();
                                                                            }}
                                                                            // onClick={() => {
                                                                            //     resendOTPFlag ? setResendOtpData() : SendLoginVerifyMobileOtp();
                                                                            // }}
                                                                            disabled={resendOTPFlag ? btnLoader.reSendOtpLoader : btnLoader.sendOtpLoader}
                                                                        >
                                                                            {resendOTPFlag ? "Resend Code" : "Send Code"}
                                                                            {(btnLoader.reSendOtpLoader || btnLoader.sendOtpLoader) && !isVisible && (
                                                                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                                                                            )}
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                        <ErrorMessage name="otp" component="div" className="error-message" />
                                                    </div>
                                                    <div className={styles.loginBtn}>
                                                        <button type="submit" className="button primary_button w-100" disabled={loading}>
                                                            Submit
                                                            {loading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                        </button>
                                                    </div>
                                                </Form>
                                            );
                                        }}
                                    </Formik>
                                    {userModel.IsMobileAuthentication && (
                                        <div className={`${styles.login_bottomtext} mt-4`}>
                                            <>
                                                Switch to{" "}
                                                <button
                                                    type="button"
                                                    className={styles.btn_link}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setIsShowMobileVerify(!isShowMobileVerify);
                                                    }}
                                                >
                                                    {isShowMobileVerify ? "GOOGLE AUTHENTICATIOR ?" : "SMS OTP ?"}
                                                </button>
                                            </>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className={`${styles.login_bottomtext} mt-3`}>
                                Go to <Link to="/login">Log in</Link>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.col_width_right} p-0 d-lg-block d-none`}>
                        <div className={styles.side_img}>
                            <img src={authImg} alt="" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
